module.exports = __webpack_public_path__ + "static/media/upload.359726ca.svg";